import * as Bowser from 'bowser'

export default function getBrowser() {
  return Bowser.getParser(window.navigator.userAgent).getBrowser()
}
